var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component, Fragment } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { SpsTooltip } from "../../tooltip";
import { uid } from "../../commercePlatform/vanilla/utils/uid";

var PRISTINE = "pristine";
var DIRTY = "dirty";
var ERROR = "error";
var VALID = "valid";

var SpsTextInput = function (_Component) {
  _inherits(SpsTextInput, _Component);

  function SpsTextInput(props) {
    _classCallCheck(this, SpsTextInput);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.showTip = function () {
      var tipShowEvent = new Event(_this.tipTriggers.show);
      if (_this.labelEl) _this.labelEl.dispatchEvent(tipShowEvent);
    };

    _this.hideTip = function () {
      var tipHideEvent = new Event(_this.tipTriggers.hide);
      if (_this.labelEl) _this.labelEl.dispatchEvent(tipHideEvent);
    };

    _this.blurHandler = function (event) {
      var blurCallback = _this.props.blurCallback;

      if (typeof blurCallback === "function") {
        blurCallback(event);
      }
      if (_this.props.required) {
        _this.validateInput(event);
      }
      _this.hideTip();
    };

    _this.focusHandler = function (event) {
      var onFocus = _this.props.onFocus;

      if (typeof onFocus === "function") {
        onFocus(event);
      }
      _this.showTip();
    };

    _this.internalChangeHandler = function (event) {
      _this.setState(function (prev, props) {
        if (prev.interactionState === PRISTINE) {
          return { interactionState: DIRTY, validity: VALID };
        } else if (prev.validity === ERROR) {
          return { validity: VALID };
        }
      });
      if (typeof _this.props.onChange === "function") {
        _this.props.onChange(event);
        _this.setState({
          internalValue: event.target.value
        });
      }

      !!event.target.value ? _this.setState({ showClearIcon: true }) : _this.setState({ showClearIcon: false });
      _this.validateInput(event);
    };

    _this.validateInput = function (event) {
      var customValidator = _this.props.customValidator;

      if (!event || !event.currentTarget) {
        return;
      }
      var input = event.target;
      var valid = true;
      if (typeof customValidator === "function") {
        valid = customValidator(String(input.value));
      }
      if (!customValidator || typeof customValidator !== "function") {
        valid = input.value !== "" && input.value.length > 0;
      }
      if (!customValidator && !_this.props.required) {
        valid = input.value === "" || input.value.length > 0;
      }
      if (!valid) {
        _this.setState({ validity: ERROR });
      } else {
        _this.setState({ validity: VALID });
      }
    };

    _this.getTip = function (tip, type) {
      return React.createElement(
        SpsTooltip,
        {
          title: tip.title,
          customTriggers: _this.tipTriggers,
          hideDelay: 0,
          kind: type,
          showOn: "manual",
          position: "top middle",
          elementFor: _this.labelId
        },
        tip.message
      );
    };

    _this.textLabel = function (name, classes, inputLabel) {
      var _this$props = _this.props,
          errorTip = _this$props.errorTip,
          infoTip = _this$props.infoTip;


      return React.createElement(
        Fragment,
        null,
        infoTip && _this.state.validity !== ERROR ? _this.getTip(infoTip, "help") : _this.state.validity === ERROR && errorTip && _this.getTip(errorTip, "error"),
        React.createElement(
          "label",
          {
            ref: function ref(el) {
              return _this.labelEl = el;
            },
            id: _this.labelId,
            htmlFor: name,
            className: classes
          },
          inputLabel
        )
      );
    };

    _this.clearInputHandler = function (e) {
      e.preventDefault();
      e.stopPropagation();

      var event = new Event("clear", { bubbles: true, cancelable: true });
      _this.element.dispatchEvent(event);
      event.target.value = "";
      _this.props.onChange(event);
      if (_this.props.required) {
        _this.setState({
          validity: ERROR,
          showClearIcon: false,
          internalValue: ""
        });
      } else {
        _this.setState({
          showClearIcon: false,
          validity: PRISTINE,
          internalValue: ""
        });
      }
    };

    _this.state = {
      interactionState: PRISTINE,
      validity: null
    };
    _this.containerRef = React.createRef();
    _this.labelId = props.labelId ? props.labelId : uid();
    _this.tipTriggers = {
      show: "show-" + _this.labelId,
      hide: "hide-" + _this.labelId
    };
    return _this;
  }

  SpsTextInput.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var controlled = !props.value && props.defaultValue;
    return {
      showClearIcon: controlled ? state.internalValue == null ? props.defaultValue.length : !!state.internalValue.length : props.value && !!props.value.length,
      internalValue: controlled ? state.internalValue == null ? props.defaultValue : state.internalValue : props.value
    };
  };

  SpsTextInput.prototype.componentDidMount = function componentDidMount() {
    if (this.labelEl) {
      this.labelEl.addEventListener("mouseenter", this.showTip);
      this.labelEl.addEventListener("mouseleave", this.hideTip);
    }
  };

  SpsTextInput.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        additionalClasses = _props.additionalClasses,
        blurCallback = _props.blurCallback,
        customValidator = _props.customValidator,
        defaultValue = _props.defaultValue,
        description = _props.description,
        disabled = _props.disabled,
        errorMessage = _props.errorMessage,
        inputLabel = _props.inputLabel,
        name = _props.name,
        placeholder = _props.placeholder,
        required = _props.required,
        Tag = _props.tag,
        render = _props.render,
        staticContext = _props.staticContext,
        value = _props.value,
        onChange = _props.onChange,
        _props$inputIcon = _props.inputIcon,
        inputIcon = _props$inputIcon === undefined ? "" : _props$inputIcon,
        errorTip = _props.errorTip,
        infoTip = _props.infoTip,
        onFocus = _props.onFocus,
        props = _objectWithoutProperties(_props, ["additionalClasses", "blurCallback", "customValidator", "defaultValue", "description", "disabled", "errorMessage", "inputLabel", "name", "placeholder", "required", "tag", "render", "staticContext", "value", "onChange", "inputIcon", "errorTip", "infoTip", "onFocus"]);

    var invalid = this.state.validity === ERROR;
    var labelClassList = classnames("sps-form-group__label sps-form-textinput-label", {
      "sps-form-group_label--required": required,
      "sps-form-group__label--description": description
    });
    var descriptionClassList = classnames("sps-form-control__description");
    var inputClassList = classnames("sps-form-control input--clearable", {
      "sps-input--error": invalid,
      "input__prefix-icon": !!inputIcon
    });
    var useInputGroup = additionalClasses.indexOf("sps-input-group") !== -1;
    var groupClassList = classnames(this.state.interactionState, {
      "sps-form-group--error": invalid
    }, {
      "sps-form-group--required": required
    }, additionalClasses, "sps-text-input");
    var inputLabelTag = inputLabel ? this.textLabel(name, labelClassList, inputLabel) : null;
    var inputIconClass = "sps-icon icon--prefix " + inputIcon;
    return React.createElement(
      Fragment,
      null,
      React.createElement(
        "div",
        { className: groupClassList, ref: this.containerRef },
        inputLabelTag,
        description && React.createElement(
          "div",
          { className: descriptionClassList },
          description
        ),
        this.state.showClearIcon && React.createElement("i", {
          className: "sps-icon sps-icon-x-circle sps-form-control__clear-btn",
          onClick: this.clearInputHandler
        }),
        React.createElement(Tag, _extends({
          ref: function ref(el) {
            return _this2.element = el;
          },
          className: inputClassList,
          type: "text",
          id: name,
          name: name,
          placeholder: placeholder,
          onFocus: this.focusHandler,
          onBlur: this.blurHandler,
          onChange: this.internalChangeHandler.bind(this),
          "aria-label": placeholder,
          value: this.state.internalValue,
          disabled: disabled,
          required: required
        }, props)),
        !!inputIcon && React.createElement("i", { className: inputIconClass })
      )
    );
  };

  return SpsTextInput;
}(Component);

export { SpsTextInput as default };


SpsTextInput.propTypes = process.env.NODE_ENV !== "production" ? {
  additionalClasses: PropTypes.array,
  blurCallback: PropTypes.func,
  customValidator: PropTypes.func,
  cols: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
  inputLabel: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  rows: PropTypes.string,
  tag: PropTypes.string,
  inputIcon: PropTypes.string,
  labelId: PropTypes.string,
  infoTip: PropTypes.shape({
    title: PropTypes.string,
    message: PropTypes.string.isRequired
  }),
  errorTip: PropTypes.shape({
    title: PropTypes.string,
    message: PropTypes.string.isRequired
  })
} : {};

SpsTextInput.defaultProps = {
  tag: "input",
  additionalClasses: []
};